import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AboutUs from '../pages/AboutUs/';
import Community from '../pages/Community/';
import ReactGA from 'react-ga';

// Sharath
import CulinaryExperience from '../pages/CulinaryExperience/';
import Eatery from '../pages/Eatery/';
import Home from '../pages/Home/';
import Listicle from '../pages/Listicle/';
import Login from '../pages/Login/';
import Story from '../pages/Story/';
import Team from '../pages/Team/';
import Search from '../pages/Search/';
import Landing from '../pages/Landing/';
import MyDashboard from '../pages/MyDashboard/';

// Dheeraj
import EateryEditor from '../pages/EateryEditor/';
import StoryEditor from '../pages/StoryEditor/';

// Shivam
import AddEditListicle from '../pages/AddEditListicle/';
import AddEditContributor from '../pages/AddEditContributor/';
import ListFollowers from '../pages/ListFollowers/';
import MyBoards from '../pages/MyBoards';

// Anit
import EateryLanding from '../pages/EateryLanding';
// import ContributorMobile from '../pages/ContributorDashboard/index2';
import ContributorExperience from '../pages/ContributorExperience/index';
import UserProfileMobile from '../pages/UserProfileMobile/';
import ContributorGuidelines from '../pages/ContributorGuidlines';
// import DashboardDesktop from '../pages/DashBoardContributor';

import CheckRoleNAuth from 'components/CheckRoleNAuth';
import userInfo from 'utils/userInfo';

const styles = theme => ({
  centering75: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
});

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      let roleProps = { ...rest };
      return userInfo.roleCheck({ roleProps }) ? (
        <Component {...props} />
      ) : (
          <CheckRoleNAuth {...props} roleProps={roleProps} />
        );
    }}
  />
);

class App extends Component {
  componentDidUpdate(prevProps) {
    let currentRoute = this.props.location.pathname + this.props.location.search;
    let oldRoute = prevProps.location.pathname + prevProps.location.search;
    if (currentRoute !== oldRoute) {
      this.onRouteChanged();
    }
  }
  componentDidMount() {
    ReactGA.initialize('UA-56337650-3');
    this.onRouteChanged();
  }
  onRouteChanged() {
    let currentRoute = this.props.location.pathname + this.props.location.search;
    ReactGA.pageview(currentRoute);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  render() {
    const { match, classes } = this.props;
    // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return (
      <div className={classes.centering75}>
        <Switch>
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}eatery/:slug/edit`}
            component={EateryEditor}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}eatery/add`}
            component={EateryEditor}
          />
          <Route
            path={`${match.path}eatery/:cityname/:eateryname`}
            component={Eatery}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}listicle/:id/edit`}
            component={AddEditListicle}
          />
          <Route
            path={`${match.path}listicle/:cityname/:listiclename`}
            component={Listicle}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}story/:slug/edit`}
            component={StoryEditor}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}story/add`}
            component={StoryEditor}
          />
          <Route
            path={`${match.path}story/:cityname/:storyname`}
            component={Story}
          />

          <Route path={`${match.path}about-us`} component={AboutUs} />
          <Route path={`${match.path}team`} component={Team} />
          <Route path={`${match.path}community`} component={Community} />
          <Route
            path={`${match.path}experiences/:cityname`}
            component={CulinaryExperience}
          />
          <Route path={`${match.path}search`} component={Search} />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}listicle/add`}
            add={true}
            component={AddEditListicle}
          />
          <PrivateRoute
            accessTo={['contributor', 'user', 'admin']}
            path={`${match.path}my-profile`}
            component={AddEditContributor}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}my-followers`}
            component={ListFollowers}
          />
          <PrivateRoute
            path={`${match.path}my-bookmarks`}
            component={MyBoards}
          />
          <Route
            path={`${match.path}eateries/:cityname`}
            component={EateryLanding}
          />
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}my-dashboard`}
            component={MyDashboard}
          />
          {/*{isMobile ? (
            <PrivateRoute
              accessTo={['contributor']}
              path={`${match.path}my-dashboard`}
              component={ContributorMobile}
            />
          ) : (
              <PrivateRoute
                accessTo={['contributor']}
                path={`${match.path}my-dashboard`}
                component={DashboardDesktop}
              />
          )}
          <PrivateRoute
            accessTo={['contributor']}
            path={`${match.path}my-dashboard/drafts`}
            component={ContributorMobile}
          />*/}
          <Route
            path={`${match.path}contributor/:contributor_id`}
            component={ContributorExperience}
          />
          <PrivateRoute
            accessTo={['user']}
            path={`${match.path}user-profile/:user_id`}
            component={UserProfileMobile}
          />
          <Route
            path={`${match.path}community_guide`}
            component={ContributorGuidelines}
          />
          <Route path={`${match.path}login`} component={Login} />
          <Route path={`${match.path}:cityname`} component={Home} />
          <Route path={`${match.path}`} component={Landing} />
        </Switch>
      </div>
    );
  }
}

export default withStyles(styles)(App);
